import { iconName } from '@/common/components/Icon'

/**
 * Shared mapping between page/menu titles and the sidebar icon set.
 * Keep this in sync with navigation labels.
 */
export const getMenuIcon = (title: string): iconName => {
  const iconMap: Record<string, iconName> = {
    Dashboard: 'home-2',
    Artists: 'star',
    Stages: 'stages',
    News: 'news',
    Map: 'map',
    Media: 'play',
    Assets: 'folder-open',
    Partners: 'heart',
    'Info Pages': 'information',
    Memories: 'memories',
    Notifications: 'notifications',
    Tickets: 'ticket-2',
    Orders: 'bag-2',
    Clients: 'profile-2user',
    Rewards: 'gift',
    'Generate Tickets': 'ticket-2',
    'Scan Tickets': 'scan-tickets',
    'Shipping Bands': 'bag-2',
    'Top Up Wristband': 'wristband',
    Referrals: 'gift',
    Settings: 'setting-3',
    Support: 'information',
    Groups: 'profile-2user',
    Festivals: 'star',
    Admins: 'profile-2user',
    Logout: 'logout',
    Vouchers: 'vouchers',
    Vendors: 'Vendor Entity',
    'Vendor Entity': 'Vendor Entity',
    Campaigns: 'campaign',
    Staff: 'staff',
    Gamification: 'flash',
  }

  return iconMap[title] || 'home-2'
}
